__turbopack_context__.v({
  "actionButtons": "Cart-module__R2U09q__actionButtons",
  "btnBack": "Cart-module__R2U09q__btnBack",
  "btnCalculate": "Cart-module__R2U09q__btnCalculate",
  "btnPrimary": "Cart-module__R2U09q__btnPrimary",
  "btnSuccess": "Cart-module__R2U09q__btnSuccess",
  "cartItem": "Cart-module__R2U09q__cartItem",
  "cartItemImage": "Cart-module__R2U09q__cartItemImage",
  "cartItemInfo": "Cart-module__R2U09q__cartItemInfo",
  "cartItemTotal": "Cart-module__R2U09q__cartItemTotal",
  "cartList": "Cart-module__R2U09q__cartList",
  "closeBtn": "Cart-module__R2U09q__closeBtn",
  "contentWrapper": "Cart-module__R2U09q__contentWrapper",
  "couponActive": "Cart-module__R2U09q__couponActive",
  "couponContainer": "Cart-module__R2U09q__couponContainer",
  "couponInputWrapper": "Cart-module__R2U09q__couponInputWrapper",
  "discount": "Cart-module__R2U09q__discount",
  "divider": "Cart-module__R2U09q__divider",
  "fadeIn": "Cart-module__R2U09q__fadeIn",
  "formInput": "Cart-module__R2U09q__formInput",
  "formSection": "Cart-module__R2U09q__formSection",
  "fullWidth": "Cart-module__R2U09q__fullWidth",
  "header": "Cart-module__R2U09q__header",
  "headerBrand": "Cart-module__R2U09q__headerBrand",
  "inputGrid": "Cart-module__R2U09q__inputGrid",
  "inputGroup": "Cart-module__R2U09q__inputGroup",
  "itemPrice": "Cart-module__R2U09q__itemPrice",
  "mainContent": "Cart-module__R2U09q__mainContent",
  "modalContainer": "Cart-module__R2U09q__modalContainer",
  "overlay": "Cart-module__R2U09q__overlay",
  "paymentCard": "Cart-module__R2U09q__paymentCard",
  "paymentGrid": "Cart-module__R2U09q__paymentGrid",
  "paymentIcon": "Cart-module__R2U09q__paymentIcon",
  "quantityWrapper": "Cart-module__R2U09q__quantityWrapper",
  "radioIndicator": "Cart-module__R2U09q__radioIndicator",
  "removeBtn": "Cart-module__R2U09q__removeBtn",
  "reviewCard": "Cart-module__R2U09q__reviewCard",
  "reviewGroup": "Cart-module__R2U09q__reviewGroup",
  "reviewItemRow": "Cart-module__R2U09q__reviewItemRow",
  "reviewItems": "Cart-module__R2U09q__reviewItems",
  "selected": "Cart-module__R2U09q__selected",
  "shippingCard": "Cart-module__R2U09q__shippingCard",
  "shippingIcon": "Cart-module__R2U09q__shippingIcon",
  "shippingInfo": "Cart-module__R2U09q__shippingInfo",
  "shippingList": "Cart-module__R2U09q__shippingList",
  "shippingName": "Cart-module__R2U09q__shippingName",
  "shippingPrice": "Cart-module__R2U09q__shippingPrice",
  "shippingTime": "Cart-module__R2U09q__shippingTime",
  "step": "Cart-module__R2U09q__step",
  "stepActive": "Cart-module__R2U09q__stepActive",
  "stepCircle": "Cart-module__R2U09q__stepCircle",
  "stepContent": "Cart-module__R2U09q__stepContent",
  "stepLabel": "Cart-module__R2U09q__stepLabel",
  "stepLine": "Cart-module__R2U09q__stepLine",
  "stepLineProgress": "Cart-module__R2U09q__stepLineProgress",
  "stepTitle": "Cart-module__R2U09q__stepTitle",
  "stepper": "Cart-module__R2U09q__stepper",
  "storeIcon": "Cart-module__R2U09q__storeIcon",
  "summaryRow": "Cart-module__R2U09q__summaryRow",
  "summarySidebar": "Cart-module__R2U09q__summarySidebar",
  "totalRow": "Cart-module__R2U09q__totalRow",
});
